export default __webpack_public_path__ + "static/media/about-us-img-09.90399a7c.jpg";